module.exports = __webpack_public_path__ + "pc/img/09_Digtal-Transformation.abe39095.png";